import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchBox from 'components/site/SearchBox';
import EquipmentWebAPIUtils from 'utils/EquipmentWebAPIUtils';
import _ from 'underscore';
class EquipmentSearch extends Component {
    constructor(props) {
        super(props);
        //  TODO: add debouncing, error handling, etc.
        this.clear = () => {
            this.setState({
                equipments: [],
                searchText: '',
            });
        };
        this.handleChange = (searchInput) => {
            this.setState({ searchInput }, () => {
                if (this.props.onSearchChange) {
                    this.props.onSearchChange(searchInput);
                }
            });
        };
        this.handleRestrictedSearch = (params) => {
            const equipment = this.props.orderEquipment;
            const query = params.equipment_id.toLowerCase();
            const matches = equipment.filter((eq) => eq.equipment_id.toLowerCase().includes(query));
            if (this.props.onSearchCompleted) {
                this.props.onSearchCompleted(matches);
            }
            this.setState({
                equipments: matches,
            });
        };
        this.handleExternalSearch = (params) => {
            EquipmentWebAPIUtils.searchEquipment(params).then((resp) => {
                const equipments = resp.entity.items;
                if (this.props.onSearchCompleted) {
                    this.props.onSearchCompleted(equipments);
                }
                this.setState({
                    equipments,
                });
            }, (err) => console.log('EquipmentSearch error: ', err));
        };
        this.handleSearch = (nGram) => {
            const params = {
                equipment_id: nGram,
            };
            if (this.props.orderEquipment && this.props.orderEquipment.length) {
                this.handleRestrictedSearch(params);
            }
            else {
                this.handleExternalSearch(params);
            }
        };
        this.renderItem = (item) => {
            return (React.createElement("a", { className: "list-group-item", style: { textDecoration: 'none' }, key: item.value },
                React.createElement("div", { className: "list-group-item-heading flex flex-row text-base" },
                    React.createElement("div", { className: "rounded text-sm text-white px-2 bg-green" }, item.equipment_id),
                    item.owner && item.owner._id ? (React.createElement("div", { className: "ml-2" }, item.owner.company_name)) : (React.createElement("div", { className: "ml-2" }, item.owner)),
                    item._equipmentType && item._equipmentType.trim() !== '' && (React.createElement("div", { className: "rounded text-sm text-white px-2 bg-blue-dark" }, item._equipmentType)))));
        };
        this.state = {
            equipments: [],
            searchText: '',
        };
    }
    handleUserSelect(value, item) {
        this.clear();
        this.props.onEquipmentSelect(item);
    }
    render() {
        const { t } = this.props;
        return (React.createElement(SearchBox, { items: this.state.equipments, value: this.state.searchText, clear: () => this.clear(), search: (nGram) => this.handleSearch(nGram), placeholder: t('SEARCH_FOR_EQUIPMENTS'), onChange: this.handleChange, onSelect: (value, item) => this.handleUserSelect(value, item), clearOnSelect: true, dropdownStyle: { maxHeight: '160px', overflow: 'auto' }, menuStyle: {
                position: 'absolute',
                top: 40,
                left: 0,
            }, getItemValue: (item) => item.equipment_id, renderItem: this.renderItem, toUpperCase: true }));
    }
}
EquipmentSearch.propTypes = {
    onEquipmentSelect: PropTypes.func.isRequired,
    onSearchCompleted: PropTypes.func,
    orderEquipment: PropTypes.array,
    onSearchChange: PropTypes.func,
};
export default withTranslation()(EquipmentSearch);
